<template>
  <div class="elePriceDetailPage">
    <el-table v-loading="loading" :data="tableData" class="tableBox" style="width: 100%">
      <template #empty>
        <el-empty class="emptyClass" description="暂无数据信息"
                  image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
        </el-empty>
      </template>
      <el-table-column label="生效日期" prop="startTime"/>
      <el-table-column label="峰谷时段" prop="priceList">
        <template #default="scope">
          <div v-for="(item,index) in scope.row.priceList" :key="index" class="item">
            <p v-if="item.type==1" class="type1 typeBox">尖</p>
            <p v-if="item.type==2" class="type2 typeBox">峰</p>
            <p v-if="item.type==3" class="type3 typeBox">平</p>
            <p v-if="item.type==4" class="type4 typeBox">谷</p>
            <p v-if="item.type==5" class="type5 typeBox">深谷</p>
            <el-input v-model="item.value" disabled>
              <template #append>元/kwh</template>
            </el-input>
          </div>
          <div v-for="(item,index) in scope.row.ladderList" :key="index" class="item">
            <p class="type6 typeBox">第{{ index + 1 }}档</p>
            <p>{{ item.downValue }}-{{ item.upValue }} kwh &nbsp; +{{ item.value }} 元/kwh</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="inUseFlag">
        <template #default="scope">
          <p :style="{background:scope.row.inUseFlag == 1?'#E8FFEA':'#FEF4E5',color:scope.row.inUseFlag == 1?'#00B42A':'#F78E00'}"
             class="status">
            {{
              scope.row.inUseFlag == 1 ? '正在使用' : '等待中'
            }}</p>
        </template>
      </el-table-column>
      <!--            <el-table-column fixed="right" label="操作">-->
      <!--              <template #default="scope">-->
      <!--                <div class="opacity">-->
      <!--                  <span class="btn" style="cursor: pointer;color: #165DFF;margin-right: 16px"-->
      <!--                        @click="editClick(scope,scope.$index)">修改</span>-->
      <!--                  <span class="btn delClass" style="color: #EF2121;cursor: pointer"-->
      <!--                        @click="delClick(scope,scope.$index)">删除</span>-->
      <!--                </div>-->
      <!--              </template>-->
      <!--            </el-table-column>-->
    </el-table>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';

import {defineProps, onMounted, ref, watch} from "vue";
import {getElePricePlanDetailApi} from "@/api/modules/rate";
import qs from "qs";
import {ElMessage} from "element-plus";

const props = defineProps(['id']);


let loading = ref(false)   // 表格加载
// 电价表格
let tableData = ref([])
// 获取电价列表
const getPowerPriceGroupPriceListFun = function () {
  loading.value = true
  getElePricePlanDetailApi(qs.stringify({id: priceId.value})).then(res => {
    loading.value = false
    if (res.data.code === 0) {
      tableData.value = [res.data.result]
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    loading.value = false
    console.log(err);
  })
}

let priceId = ref()
watch(() => props.id, (newVal) => {
  priceId.value = newVal
  if (priceId.value) {
    getPowerPriceGroupPriceListFun()
  }
}, {immediate: true, deep: true})


onMounted(() => {
  // getPowerPriceGroupPriceListFun()

})
</script>


<style lang="less">
.elePriceDetailPage {
  .tableBox {
    .item {
      display: flex;
      align-items: center;
      margin: 10px 0;

      .el-input {
        width: 160px;
      }

      .typeBox {
        padding: 0 4px;
        color: #fff;
        border-radius: 3px;
        height: 22px;
        line-height: 22px;
        margin-right: 6px;
      }

      .type1 {
        background: #F21110;
      }

      .type2 {
        background: #F57244;
      }

      .type3 {
        background: #50D5D9;
      }

      .type4 {
        background: #3587DA;
      }

      .type5 {
        background: #748EE3;
      }

      .type6 {
        background: #A084FA;
      }

      > p {
        display: inline-block;
      }
    }

    .status {
      padding: 0 8px;
      border-radius: 3px;
      display: inline-block;
    }
  }
}
</style>
